import React from 'react';
import { View, Text, StyleSheet } from 'react-native';
import { colors, fontSize, fontWeight } from '../../theme';

interface FieldFillCountBadgeProps {
  filled: number;
  total: number;
}

/**
 * Pill badge for subsection header field progress (#1011): e.g. `4/17` beside the chevron.
 */
export const FieldFillCountBadge: React.FC<FieldFillCountBadgeProps> = ({ filled, total }) => (
  <View
    testID="field-fill-count-badge"
    style={styles.badge}
    accessibilityLabel={`${filled} of ${total} fields entered`}
  >
    <Text style={styles.text}>
      {filled}/{total}
    </Text>
  </View>
);

const styles = StyleSheet.create({
  badge: {
    backgroundColor: colors.backgroundSecondary,
    borderRadius: 999,
    borderWidth: 1,
    borderColor: colors.borderMedium,
    paddingHorizontal: 10,
    paddingVertical: 2,
    minWidth: 36,
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: 0,
  },
  text: {
    color: colors.textSecondary,
    fontSize: fontSize.cardSubtitle,
    fontWeight: fontWeight.semibold,
    textAlign: 'center',
    lineHeight: fontSize.cardSubtitle + 2,
  },
});
